/**
 * Converts font names into a Google Fonts URL format
 * @param {string|string[]} fontNames - Single font name or array of font names (e.g., "Noto Sans" or ["Noto Sans", "Lato"])
 * @returns {string} Google Fonts URL with formatted font names (e.g., "https://fonts.googleapis.com/css2?family=Noto+Sans&family=Lato&display=swap")
 */
export function getGoogleFontsUrl(fontNames) {
  // If single font name is passed as string, convert to array
  const fonts = Array.isArray(fontNames) ? fontNames : [fontNames];

  // Convert font names to Google Fonts format. Encode, then use plus signs for spaces
  const formattedFonts = fonts.map((font) => {
    return encodeURIComponent(font.trim()).replace(/%20/g, "+");
  });

  // Build the Google Fonts URL
  const baseUrl = "https://fonts.googleapis.com/css2?";
  const fontFamilies = formattedFonts.map((font) => `family=${font}`).join("&");
  const displayParam = "&display=swap";

  return `${baseUrl}${fontFamilies}${displayParam}`;
}

/**
 * Builds a CSS font-family value with the brand font quoted ahead of a fallback stack
 * @param {string|undefined} font - Brand font name (e.g., "Source Sans 3")
 * @param {string} fallback - Fallback stack (e.g., "sans-serif")
 * @returns {string} e.g. '"Source Sans 3", sans-serif'
 */
export function getFontStack(font, fallback) {
  const sanitized = font?.replace(/[^A-Za-z0-9 -]/g, "").trim();
  return sanitized ? `"${sanitized}", ${fallback}` : fallback;
}
